import React from 'react'

export interface TransitionGroupContextValue {
  isMounting: boolean
}

export default React.createContext<TransitionGroupContextValue | null>(null)
